/** Matches ASP.NET `{id:guid}` route parameter (churn-signals/.../create-ticket). */
const GUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

/**
 * Returns the first candidate that is a valid GUID string, or null.
 * Prefer database `id` over display `signalId` when both are present.
 */
export function firstChurnSignalGuid(...candidates: (string | undefined | null)[]): string | null {
  for (const c of candidates) {
    const t = typeof c === 'string' ? c.trim() : '';
    if (t && GUID_RE.test(t)) {
      return t;
    }
  }
  return null;
}
